import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, SERVICES, PHONE_TEL, PHONE_DISPLAY, EMAIL, CITY, HOURS, SOCIALS, WHATSAPP_URL, MAP_LINK } from "../../lib/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

const SOCIAL_ICONS = { Facebook };

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-[#D4AF37]/15 bg-[#05030A]">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-12 lg:px-12 lg:py-20">
      <div className="lg:col-span-4">
        <Logo testId="footer-logo" />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          Astrology, psychic readings and spiritual healing in Calgary, Alberta — offered with care,
          discretion and respect for every question you bring.
        </p>
        <div className="mt-6 flex gap-3">
          {SOCIALS.map((s) => {
            const Icon = SOCIAL_ICONS[s.name];
            return (
              <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.name} data-testid={`footer-social-${s.name.toLowerCase()}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#D4AF37]/25 text-slate-300 transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]">
                <Icon className="h-4 w-4" />
              </a>
            );
          })}
        </div>
      </div>
      <div className="lg:col-span-2">
        <h3 className="font-cinzel text-xs tracking-[0.25em] text-[#D4AF37]">EXPLORE</h3>
        <ul className="mt-5 space-y-3 text-sm">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase()}`} className="text-slate-300 transition-colors hover:text-[#F3E5AB]">{n.label}</Link></li>
          ))}
        </ul>
      </div>
      <div className="lg:col-span-3">
        <h3 className="font-cinzel text-xs tracking-[0.25em] text-[#D4AF37]">SERVICES</h3>
        <ul className="mt-5 grid grid-cols-1 gap-2.5 text-sm">
          {SERVICES.slice(0, 6).map((s) => (
            <li key={s.id}><Link to={`/book?service=${s.id}`} className="text-slate-300 transition-colors hover:text-[#F3E5AB]">{s.title}</Link></li>
          ))}
          <li><Link to="/services" className="text-[#D4AF37] hover:text-[#F3E5AB]">All services →</Link></li>
        </ul>
      </div>
      <div className="lg:col-span-3">
        <h3 className="font-cinzel text-xs tracking-[0.25em] text-[#D4AF37]">CONTACT</h3>
        <ul className="mt-5 space-y-3 text-sm text-slate-300">
          <li><a href={PHONE_TEL} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white"><Phone className="h-4 w-4 text-[#D4AF37]" />{PHONE_DISPLAY}</a></li>
          <li><a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 hover:text-white"><WhatsAppIcon className="h-4 w-4 text-[#D4AF37]" />WhatsApp {PHONE_DISPLAY}</a></li>
          <li><a href={`mailto:${EMAIL}`} data-testid="footer-email" className="flex items-center gap-3 break-all hover:text-white"><Mail className="h-4 w-4 shrink-0 text-[#D4AF37]" />{EMAIL}</a></li>
          <li><a href={MAP_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-map" className="flex items-center gap-3 hover:text-white"><MapPin className="h-4 w-4 text-[#D4AF37]" />{CITY}</a></li>
          {HOURS.map((h) => (
            <li key={h.day} className="text-slate-400">{h.day}: <span className="text-slate-300">{h.time}</span></li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-[#D4AF37]/10">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-2 px-5 py-6 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between sm:px-8 lg:px-12">
        <p>© {new Date().getFullYear()} Astrologer &amp; Spiritual Healers · Calgary, Alberta</p>
        <p>Readings are offered for guidance and personal reflection.</p>
      </div>
    </div>
  </footer>
);
